<template>
  <page-wrap>
    <vehicle-manage-panel source="hik" :use-hik-api="true" :readonly="true" :extended-filters="true" />
  </page-wrap>
</template>

<script>
import PageWrap from '../components/PageWrap'
import VehicleManagePanel from '../components/VehicleManagePanel'

export default {
  name: 'CheliangHikView',
  components: { PageWrap, VehicleManagePanel }
}
</script>
